import React, { useEffect, useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import { useHistory, useParams } from 'react-router-dom';
import { useGetCmsHelpsQuery } from '../../apis/cmsApi/cms.hooks.api';
import { BaseLayout } from '../../components/Layout/Layout';
import { getFaqs } from '../../helpers/help';
import { useBack } from '../../hooks/useBack';
import { useLanguage } from '../../locale/useLanguage';
import { FaqFeature } from '../../models';
import { Routes } from '../../routes/types';

import './FaqDetailsView.css';

type FaqDetailsRoutingProps = {
  feature?: FaqFeature;
  faqId?: string;
};

type FaqDetailsViewProps = {};

export const FaqDetailsView: React.FC<FaqDetailsViewProps> = () => {
  const languagesInfo = useLanguage();
  const history = useHistory();
  const t = languagesInfo[0];
  const locale = languagesInfo[2];
  const back = useBack();
  const { faqId, feature } = useParams<FaqDetailsRoutingProps>();

  const { isLoading, data: helps } = useGetCmsHelpsQuery({ locale });

  const faqPage = useMemo(() => {
    if (!helps || !feature) return undefined;

    const faqs = getFaqs(helps, feature);
    return faqs.find((h) => h.id === Number(faqId));
  }, [faqId, feature, helps]);

  useEffect(() => {
    if (!feature || !faqId) {
      history.replace(Routes.Home);
    }
  }, [faqId, feature, history]);

  return (
    <BaseLayout
      title={t('pageTitles.faq')}
      hasBack
      onBackClick={back}
      isLoading={isLoading}
    >
      <div className="faq-details--container">
        {faqPage ? (
          <>
            <h2 className="subtitle">{faqPage.title}</h2>
            <ReactMarkdown>{faqPage.content}</ReactMarkdown>
          </>
        ) : (
          <div>Content not exist</div>
        )}
      </div>
    </BaseLayout>
  );
};
